import { render } from "./reservation.vue?vue&type=template&id=b7607e18&scoped=true"
import script from "./reservation.vue?vue&type=script&lang=js"
export * from "./reservation.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b7607e18"

export default script